import styled from 'styled-components';

import ActionButton from 'components/action-button';

export const StyledButton = styled(ActionButton)`
  font-size: 0.875rem;
  line-height: 0.875rem;
  letter-spacing: 0.5px;
  padding: 0.3125rem 1.375rem;
  border-width: 0.125rem;
  margin: 0 auto 1rem;
`;
